import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import FragmentWrapper from 'graphql-client/FragmentWrapper';
import {FullExecutionSampleFragment} from 'registry/execution/graphql/FullExecutionSample';

import {GraphQLRequestSampleGroupsRelationship} from './__generated/GraphQLRequestSampleGroupsRelationship';
import {GraphQLRequestTasksRelationship} from './__generated/GraphQLRequestTasksRelationship';
import {RequestSampleGroups} from './__generated/RequestSampleGroups';
import {RequestTasks} from './__generated/RequestTasks';

// Callers should prefer RequestTasksFragment - this is factored out more granularly for syncing.
// Corresponds to requestTasksFetchedForRequests action
const REQUEST_TASKS_RELATIONSHIP_FRAGMENT: DocumentNode = gql`
  fragment GraphQLRequestTasksRelationship on RequestNode {
    id
    tasks {
      id
      sampleGroups {
        id
      }
    }
  }
`;

export const RequestTasksRelationshipFragment: FragmentWrapper<GraphQLRequestTasksRelationship> = {
  fragment: REQUEST_TASKS_RELATIONSHIP_FRAGMENT,
  fragmentName: 'GraphQLRequestTasksRelationship',
};

// Corresponds to fetchTasksForRequests action
const REQUEST_TASKS_FRAGMENT: DocumentNode = gql`
  fragment RequestTasks on RequestNode {
    id
    ...GraphQLRequestTasksRelationship
    tasks {
      id
      ...RequestTaskGraphQL
    }
  }
  ${getFragmentWrapper('RequestTask').fragment}
  ${RequestTasksRelationshipFragment.fragment}
`;

export const RequestTasksFragment: FragmentWrapper<RequestTasks> = {
  fragment: REQUEST_TASKS_FRAGMENT,
  fragmentName: 'RequestTasks',
};

// Callers should prefer RequestSampleGroupsFragment - this is factored out more granularly for syncing.
// Corresponds to requestSampleGroupsFetchCompleted action.
const REQUEST_SAMPLE_GROUPS_RELATIONSHIP_FRAGMENT: DocumentNode = gql`
  fragment GraphQLRequestSampleGroupsRelationship on RequestNode {
    id
    sampleGroups {
      id
    }
  }
`;

export const RequestSampleGroupsRelationshipFragment: FragmentWrapper<GraphQLRequestSampleGroupsRelationship> =
  {
    fragment: REQUEST_SAMPLE_GROUPS_RELATIONSHIP_FRAGMENT,
    fragmentName: 'GraphQLRequestSampleGroupsRelationship',
  };

// Corresponds to fetchRequestSampleGroups action
const REQUEST_SAMPLE_GROUPS_FRAGMENT: DocumentNode = gql`
  fragment RequestSampleGroups on RequestNode {
    id
    ...GraphQLRequestSampleGroupsRelationship
    sampleGroups {
      id
      ...SampleGroupGraphQL
      samples {
        ...FullExecutionSample
      }
    }
  }
  ${getFragmentWrapper('SampleGroup').fragment}
  ${RequestSampleGroupsRelationshipFragment.fragment}
  ${FullExecutionSampleFragment.fragment}
`;

export const RequestSampleGroupsFragment: FragmentWrapper<RequestSampleGroups> = {
  fragment: REQUEST_SAMPLE_GROUPS_FRAGMENT,
  fragmentName: 'RequestSampleGroups',
};
